import { React, useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/bundle";
import { EffectCoverflow, FreeMode, Pagination, Navigation } from "swiper";
import { Removecontinuewatch, RemoveallcontinueWatching } from "../../Model/Users";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Link, useHref } from "react-router-dom";
import $ from "jquery";
import { isMobile } from "react-device-detect";

var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));
export function Continue(props) {
  const [showpopup, setshowpopup] = useState(false);
  const [contentdata, setcontentdata] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  // const [showShimmer, setShowShimmer] = useState(true);

  // const handleTimeout = useCallback(() => {
  //   setShowShimmer(false);
  // }, []);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //     setShowShimmer(false);
  //   // }, 1000);

  //   // return () => {
  //   //   clearTimeout(timer);
  //   // };
  // }, [handleTimeout]);

  function watchpopup(data) {
    setshowpopup(true);
    setcontentdata(data);
  }

  function removecontinuewatch(id) {
    var data = {
      "content_id": [id]
    }
    Removecontinuewatch(data).then((Response) => {
      if (Response.data.success == true) {
        document.getElementById("continue_" + id).remove();
        if ($(".continue_watching")[0]) {
        } else {
          document.getElementById("continue_watching_master").remove();
        }
        setshowpopup(false);
      }
    })
  }

  function removeallcontinuewatch(id) {
    var data = {
      "content_id": [id]
    }
    RemoveallcontinueWatching(data).then((Response) => {
      if (Response.data.success == true) {
        document.getElementById("continue_watching_master").remove();
        setShowConfirm(false);
      }
    })
  }

  let closeButton = () => {
    setshowpopup(false);
  };

  const cancel = () => {
    setShowConfirm(false);
  };

  const watchconfirm = () => {
    setShowConfirm(true);
  }

  let Watchlistconfirm = null;
  if (showConfirm) {
    Watchlistconfirm = (
      <div className="logOutpopup">
        <div className="temp52-modal-body">
          <div className="temp52-awesome">
            <h6>Are you sure you want to clear your list?</h6>
          </div>
          <p className="temp52-modal-close" onClick={cancel}>
            No
          </p>
          <button type="submit" id="sendEnquiryBtn" className="btn-white" onClick={() => { removeallcontinuewatch(props.data?.ID) }}>
            Yes
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <section className="mb-0" id="continue_watching_master">
        <div className="temp22">
          {/* {showShimmer ? (
            <div className="line linehead linedesk" />
          ) : ( */}
          <>
            <div className="head head-layout continue-head">
              <h3>Continue <span className="red">Watching</span></h3>
              <h3 className="clr-all" onClick={() => watchconfirm()}>Clear All</h3>
            </div>
          </>
          {/* )} */}

          <div className="temp22-area">
            <Swiper
              navigation={{
                prevEl: ".slick-prev",
                nextEl: ".slick-next",
              }}
              spaceBetween={16}
              slidesPerView={1.2}
              freeMode={true}
              slidesPerGroup={4}
              loop={false}
              centeredSlides={false}
              breakpoints={{
                650: {
                  slidesPerView: 3,
                },
                850: {
                  slidesPerView: 4,
                },
              }}
              modules={[Navigation, FreeMode, Pagination]}
              className="temp22-slider">
              <div className="side-overlay-L dD-block"></div>
              <button className="slick-prev slick-arrow dD-block" type="button" aria-label="Previous" />
              {
                props.Layout1.map((data) => {
                  var GenereTitle = data.genres.split(",");
                  GenereTitle = GenereTitle[0];
                  var Percentage = (data.user_duration / data.duration) * 100;
                  var timeremaining = data.duration - data.user_duration;
                  return (
                    <SwiperSlide key={"continue_" + data.ID} id={"continue_" + data.ID} className="temp22-item continue_watching">
                      {/* {showShimmer ? (
                        <img src={ImageData["placeholder3.png"]} alt="shimmer" className="shimmer" />
                      ) : ( */}
                      <>
                        <Link to={"/" + data.slug}>
                          <div className="temp22-itemColor">
                            <img
                              src={data.banner_image.medium}
                              alt="DocuBay"
                            />
                            <img src={SVGIcon['play-2.svg']} className="docbus-btn" />
                            <div className="premium-red">
                              {" "}
                              <img src={ImageData['premium-red.png']} />{" "}
                            </div>
                            <div className="progress">
                              <div className="progress-bar" style={{ width: "" + Percentage + "%" }} />
                            </div>
                            <div className="temp22-itemColor-bshow" />
                          </div>
                        </Link>
                        <div className="bay-title temp22-text">{Math.floor(timeremaining / 60)} Mins Left
                          {isMobile ? <>
                            <img src={SVGIcon['contine-watch.svg']} alt="DocuBay" onClick={() => watchpopup(data)} />
                          </> :
                            <img src={ImageData["Delete-Icon-1.png"]} alt="DocuBay" onClick={() => { removecontinuewatch(data.ID) }} />
                          }
                        </div>
                      </>
                      {/* )} */}
                    </SwiperSlide>
                  );
                })
              }
              {/* <SwiperSlide>
              </SwiperSlide> */}
              <div className="side-overlay-R dD-block"></div>
              <button className="slick-next slick-arrow dD-block" type="button" aria-label="Next" />
            </Swiper>
          </div>
        </div>
      </section>
      {Watchlistconfirm}

      {showpopup ? (
        <div
          className="bannerpop"
          id="bPop"
          style={{ display: "flex" }}
        >
          <div className="bannerpop-modal-body">
            <button className="bannerpop-modal-close bannerpop-modal-toggle" onClick={() => { closeButton() }}>
              <img src="img/svg/promocode-close.svg" alt="Docubay" />
            </button>
            <div className="bannerpop-awesome">
              <h5>{contentdata.title}</h5>
              <Link to={"/" + contentdata.slug}>
                <h6>
                  <img src={SVGIcon["more-info.svg"]} /> More Info
                </h6>
              </Link>
              <h6 onClick={() => { removecontinuewatch(contentdata.ID) }}>
                <img src={SVGIcon["remove-list.svg"]} /> Remove from
                List
              </h6>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Continue;